export enum PaymentMethodType {
  Visa = "visa",
  Maestro = "maestro",
  MasterCard = "mc",
  AmericanExpress = "amex",
  Discover = "discover",
  Diners = "diners",
  Accel = "accel",
  Star = "star",
  ACH = "ach",
  Interac = "interac_card"
}

export enum PaymentStatus {
  Success = "Success",
  Failed = "Failed",
  Failure = "Failure",
  Pending = "Pending",
  Refunded = "Refunded",
  Aborted = "Aborted",
  Cancelled = "Cancelled",
  PendingRefund = "Pending Refund",
  Authorised = "Authorised",
  LinkSent = "Link Sent",
  CardSaved = "Card Saved",
  Chargeback = "Chargeback",
  RefundFailed = "Refund Failed",
  PartialRefunded = "Partial Refunded",
  AutoReversal = "Reverted"
}

export enum CardType {
  CreditSale = "CreditSale",
  DebitSale = "DebitSale"
}

export enum StartTransactionType {
  CreditSale = 0,
  CreditReturn = 1,
  CreditAuth = 2,
  CreditSaveCard = 3,
  RequestSignature = 4,
  SaveCard = 5
}
